import { configureStore, createSlice } from "@reduxjs/toolkit";
import axiosService from "../../lib/Axios";
import { iAuthenticationState } from "../../lib/Interfaces/Authentication";
import { reducer } from './reducer'

//This is a reducer function which works similar to the Array reduce method in JS.
//The first param is the state before and the second is the action being applied to that state
//Reducers should neve change the previous state of the app



export interface AuthSettingsState {
    authSettings?: iAuthenticationState
  }
  

//Redux actions
interface PostAuthAttempt {
    // type: "SET_LOGIN"
    type: "SET_AUTH_STATE_AFTER_POST_LOGIN"
    authSettings: iAuthenticationState
}
interface ClearAuthOnLogout {
    // type: "SET_LOGIN"
    type: "CLEAR_AUTH_STATE_ON_LOGOUT"
}

export const unloadedAuthState : AuthSettingsState = {
    authSettings: {
        isAuthenticated: false,
        accessToken : '',
        expireInSeconds : 0,
        realitexUserName: ''
    }
}


export type KnownAuthStateActionsType = PostAuthAttempt | ClearAuthOnLogout;



export { reducer }